import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';

class DeliveryChallanItemAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/deliverychallan/:deliveryChallanId/item');
  }

  resolveParameterizedUrlVariables(meta: MetaQuery | undefined) {
    let url = this.baseURL?.replace(':deliveryChallanId', meta?.deliveryChallanId);
    return url;
  }

  protected transformNode(node: any) {
    node.quantity = 1;
    return node;
  }
}

export default DeliveryChallanItemAPIClient;
